import axios from 'axios'
import { tansParams } from '@/utils/public'
import { Notification, MessageBox, Message, Loading } from 'element-ui'

// import errorCode from '@/utils/errorCode'
// import cache from '@/plugins/cache'

// let downloadLoadingInstance;
// // 是否显示重新登录
// export let isRelogin = { show: false };

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    //   baseURL: '192.168.3.181:10106',
    baseURL: '/prod-api', //线上地址
    // baseURL: '/stage-api', //测试地址
    // 超时
    timeout: 10000
})
// request拦截器
service.interceptors.request.use(config => {

    if (config.method === 'get' && config.params) {
        let url = config.url + '?' + tansParams(config.params);
        url = url.slice(0, -1);
        config.params = {};
        config.url = url;
    }
    return config
}, error => {
    console.log(error)
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 二进制数据则直接返回
    if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
        return res.data
    }

    if (code === 200) {
        return res.data
    } else {
        Message({ message: res.data.msg, type: 'error' })
        return Promise.reject(res.data.msg)
    }
})



export default service



// WEBPACK FOOTER //
// ./src/api/index.js